import { S as C, b as v, c as F } from "./filters-Cwo0Aj2k.js";
import { MetricGrowthType as l, GrowthLabel as T, GrowthPreffix as E, MetricExtraConfKeys as G, MetricTitlePart as O, ChartGrowth as m } from "./configuration/types.js";
import "dayjs";
import { T as o, a as M } from "./period-BbmcGyLd.js";
import { useCallback as q } from "react";
import { ColorTypes as U } from "./selector/metrics/options/MetricOptionForm.types.js";
import { l as N } from "./lodash-DeBCDn4U.js";
import { SemanticType as A } from "./MetaModel.js";
import { isEmpty as b, notEmpty as $ } from "@biron-data/react-components";
import { getFilterResume as H } from "./selector/comps/box/utils.js";
const fe = (e) => [...new Set(e.map(({ viewCode: t }) => t))].length > 1, L = (e) => {
  const { growth: t } = e, { unit: s, formatPrefix: i, formatSuffix: r, formatPrecision: n, growthInvert: a, asRatio: f } = Z(e);
  return t ? {
    prefix: t.type === l.RATIO ? "" : i,
    suffix: t.type === l.RATIO ? "%" : r,
    nDecimal: t.type === l.RATIO ? 2 : n,
    asRatio: t.type === l.RATIO,
    growth: !0,
    unit: s,
    growthInvert: !!a,
    type: t.type
  } : {
    prefix: i,
    suffix: r,
    nDecimal: n,
    growth: !1,
    asRatio: f,
    unit: s
  };
}, I = (e, t) => {
  var s;
  return (s = e.getView(t.viewCode)) == null ? void 0 : s.metrics.find(({ code: i }) => i === t.metricCode);
}, W = (e, t) => e.suffix !== t.suffix || e.prefix !== t.prefix, _ = (e, t) => e.metricDef && t.metricDef && W(L(e), L(t)), R = (e, t) => !!t.find(
  (s) => _(e, s)
), ce = (e, t, s, i) => {
  const r = s.map((c) => ({
    ...c,
    metricDef: I(i, c)
  })), n = r.filter((c) => {
    var u;
    return !((u = c.extraConf) != null && u.isDisplayedOnSecondaryAxis);
  }), a = r.filter((c) => {
    var u;
    return (u = c.extraConf) == null ? void 0 : u.isDisplayedOnSecondaryAxis;
  }), f = {
    ...t,
    metricDef: I(i, t),
    metricAlias: ""
  };
  if (!r.find((c) => !c.metricDef) && f.metricDef) {
    if (a.length === 0 && R(f, r))
      return !0;
    if (a.length > 0 && !R(f, a))
      return !(a.length > 0 && !R(f, n));
  }
  return !1;
}, oe = (e) => (e == null ? void 0 : e.unit) === o.DAY && b(e == null ? void 0 : e.quantity) ? "previous" : (e == null ? void 0 : e.unit) === o.YEAR ? "y-n" : (e == null ? void 0 : e.unit) === o.DAY ? "d-n" : (e == null ? void 0 : e.unit) === o.WEEK ? "w-n" : (e == null ? void 0 : e.unit) === o.MONTH ? "m-n" : (e == null ? void 0 : e.unit) === o.QUARTER ? "q-n" : null, ue = (e) => e ? 1 : 0, B = (e) => {
  var t;
  return !(e.growthType === l.RATIO || ((t = e.metricDef) == null ? void 0 : t.formatSuffix) === "%");
}, V = (e) => e.type === "date", j = (e) => e.type === "date", Y = (e) => e.type === "dimension", le = (e) => {
  const t = e.filter(V);
  return t == null ? void 0 : t[0];
}, pe = (e) => {
  const t = e.filter(j);
  return t == null ? void 0 : t[0];
}, de = (e) => e.filter(Y), ye = (e) => e.filter(Y), k = (e, t, s) => e.find((i) => i.code === s && i.metrics.find((r) => r.code === t)), K = (e, {
  metricCode: t,
  metricAlias: s,
  viewCode: i
}, r = !1) => {
  const n = k(e, String(t), String(i));
  return r && n ? `${n.alias}/${s}` : s;
}, ve = ({
  dashboardSelection: e,
  chartPeriod: t
}, s) => {
  var r, n;
  const i = t && s ? {
    period: t,
    start: (r = M(t)) == null ? void 0 : r.start,
    end: (n = M(t)) == null ? void 0 : n.end,
    source: C.CHART
  } : {
    period: e.date.period,
    start: e.date.start,
    end: e.date.end,
    source: C.QUERY
  };
  return {
    period: i.period,
    start: i.start ? i.start.format("YYYY-MM-DD") : "",
    end: i.end ? i.end.format("YYYY-MM-DD") : "",
    source: i.source
  };
}, Te = (e) => ({
  ...N.omit(e, ["growthInvert", "activated", "filters", "growthPeriod", "growthType", "interval", "gradient", "type", ...Object.keys(G)]),
  growth: e.growthPeriod && e.growthType ? {
    period: e.growthPeriod,
    type: e.growthType
  } : void 0,
  titlePartOverrides: {
    [O.FILTER]: e.additionalFiltersLabel,
    [O.PERIOD]: e.overridePeriodLabel,
    [O.GROWTH]: e.growthLabel
  },
  extraConf: {
    growthInvert: e.growthInvert,
    isDisplayedOnSecondaryAxis: e.isDisplayedOnSecondaryAxis,
    growthLabel: e.growthLabel,
    color: e.color,
    units: B(e) ? e.units : null,
    decimals: e.decimals,
    details: e.details,
    interval: e.interval,
    gradient: e.gradient,
    type: e.type
  }
}), me = (e, t, s, i) => q((r) => t.map((n) => {
  var p, x;
  const a = r.find((y) => y.metricCode === n.metricCode), f = a ? I(e, a) : void 0, c = a && i ? K(i, {
    metricCode: a.metricCode,
    metricAlias: a.metricAlias,
    viewCode: a.viewCode
  }, !0) : n.reference.id, u = (f == null ? void 0 : f.asRatio) && (f.formatSuffix === "%" || f.formatPrefix === "%") || ((x = (p = r.find((y) => (s ? c : n.reference.alias) === y.metricAlias)) == null ? void 0 : p.growth) == null ? void 0 : x.type) === l.RATIO;
  return {
    ...n,
    reference: {
      id: c ?? n.reference.id,
      alias: s ? c ?? n.reference.alias : n.reference.alias,
      code: (a == null ? void 0 : a.metricCode) ?? n.reference.code,
      ...a && f ? {
        description: f.description ?? "",
        prefix: u ? "" : f.formatPrefix,
        suffix: u ? "%" : f.formatSuffix,
        asPercentage: u
      } : {}
    }
  };
}), [t, s, e, i]), Oe = (e) => e.map((t) => {
  if (t.having)
    switch (t.having.operator) {
      case v.BETWEEN:
        return {
          type: F.metric,
          metricCode: t.metricCode,
          dataType: A.NUMBER,
          isValid: !0,
          reference: {
            alias: t.metricAlias,
            code: t.metricCode
          },
          predicate: t.having
        };
      case v.GT:
      case v.GTE:
      case v.LT:
      case v.LTE:
      case v.EQ:
        return {
          type: F.metric,
          metricCode: t.metricCode,
          dataType: A.NUMBER,
          isValid: !0,
          reference: {
            alias: t.metricAlias,
            code: t.metricCode
          },
          predicate: t.having
        };
      default:
        return t.having;
    }
}).filter($), Q = (e, t) => e.map((s) => {
  const i = t == null ? void 0 : t.find((r) => r.code === s.dimensionCode);
  return {
    ...s,
    isValid: !0,
    type: F.dimension,
    dataType: (i == null ? void 0 : i.semanticType) ?? A.STRING,
    reference: {
      alias: (i == null ? void 0 : i.alias) ?? s.dimensionCode,
      code: (i == null ? void 0 : i.code) ?? s.dimensionCode,
      description: i == null ? void 0 : i.description,
      dictionaryCode: i == null ? void 0 : i.dictionaryCode
    }
  };
}), D = (e, t) => e.map((s) => {
  const i = t == null ? void 0 : t.find((r) => r.code === s.dimensionCode);
  return {
    ...s,
    isValid: !0,
    reference: {
      alias: i == null ? void 0 : i.alias,
      code: i == null ? void 0 : i.code,
      description: i == null ? void 0 : i.description,
      dictionaryCode: i == null ? void 0 : i.dictionaryCode
    },
    dataType: (i == null ? void 0 : i.semanticType) ?? A.STRING
  };
}), g = (e) => e != null && e.type ? e == null ? void 0 : e.type : e != null && e.color ? U.fixed : null, xe = (e, t) => {
  var s, i, r, n, a, f, c, u, d, p, x, y;
  return {
    ...N.omit(e, ["extraConf", "having", "growth"]),
    ...e.extraConf,
    units: ((s = e.extraConf) == null ? void 0 : s.units) ?? null,
    color: ((i = e.extraConf) == null ? void 0 : i.color) ?? null,
    type: g(e.extraConf),
    decimals: (r = e.extraConf) == null ? void 0 : r.decimals,
    details: (n = e.metricDef) != null && n.formatSuffix || (a = e.metricDef) != null && a.formatSuffix ? {
      type: (f = e.metricDef) != null && f.formatSuffix ? "suffix" : "prefix",
      value: ((c = e.metricDef) == null ? void 0 : c.formatSuffix) ?? ((u = e.metricDef) == null ? void 0 : u.formatSuffix)
    } : (d = e.extraConf) == null ? void 0 : d.details,
    growthPeriod: (p = e.growth) == null ? void 0 : p.period,
    growthType: (x = e.growth) == null ? void 0 : x.type,
    activated: !!((y = e == null ? void 0 : e.growth) != null && y.type),
    additionalFilters: Q(D(e.additionalFilters, t), t),
    additionalFiltersLabel: e.titlePartOverrides[O.FILTER],
    overridePeriodLabel: e.titlePartOverrides[O.PERIOD],
    growthLabel: e.titlePartOverrides[O.GROWTH]
  };
}, Ee = (e, t) => {
  var s, i;
  return {
    ...t,
    ...e,
    details: e.details && (e.details.type === "prefix" && e.details.value !== ((s = t.metricDef) == null ? void 0 : s.formatPrefix) || e.details.type === "suffix" && e.details.value !== ((i = t.metricDef) == null ? void 0 : i.formatSuffix)) ? e.details : void 0
  };
}, S = (e) => (e == null ? void 0 : e.unit) === o.DAY && b(e == null ? void 0 : e.quantity) ? m.TRANSLATED : (e == null ? void 0 : e.unit) === o.DAY ? m.DAY_MINUS_ONE : (e == null ? void 0 : e.unit) === o.WEEK ? m.WEEK_MINUS_ONE : (e == null ? void 0 : e.unit) === o.MONTH ? m.MONTH_MINUS_ONE : (e == null ? void 0 : e.unit) === o.QUARTER ? m.QUARTER_MINUS_ONE : (e == null ? void 0 : e.unit) === o.YEAR ? m.YEAR_MINUS_ONE : null, z = (e, t) => {
  var s, i, r, n, a, f, c, u;
  if (e.titlePartOverrides.GROWTH)
    return e.titlePartOverrides.GROWTH;
  if (e.growth === void 0)
    return "";
  switch ((s = e.growth) == null ? void 0 : s.type) {
    case l.DIFFERENCE:
      return `(vs ${t.get(`growth.value.${S((i = e.growth) == null ? void 0 : i.period)}`, (r = e.growth) == null ? void 0 : r.period.quantity)})`;
    case l.VALUE:
      return `(${t.get(`growth.value.${S((n = e.growth) == null ? void 0 : n.period)}`, (a = e.growth) == null ? void 0 : a.period.quantity)})`;
    case l.RATIO:
      return `(% vs ${t.get(`growth.value.${S((f = e.growth) == null ? void 0 : f.period)}`, (c = e.growth) == null ? void 0 : c.period.quantity)})`;
    case void 0:
      return "";
    case null:
      return "";
    default:
      (u = e.growth) == null || u.type;
      return;
  }
}, J = (e, t) => e.titlePartOverrides.FILTER ? e.titlePartOverrides.FILTER : e.additionalFilters.length === 0 ? "" : e.additionalFilters.map((s) => `${s.reference.alias}: ${H(s, t)}`).join(", "), X = (e, t) => e.titlePartOverrides.PERIOD ? e.titlePartOverrides.PERIOD : e.overridePeriod === void 0 ? "" : t.getTranslatedName(e.overridePeriod);
function Ae(e, t) {
  var i;
  const { metricDef: s } = e;
  return s ? `${(i = e.metricDef) == null ? void 0 : i.alias} ${J(e, t)} ${X(e, t)} ${z(e, t)}` : "";
}
const Re = Object.freeze({
  "last-period": [
    {
      value: {
        unit: o.DAY,
        quantity: void 0
      },
      label: T.previous
    }
  ],
  "dynamic-period": [
    {
      value: {
        unit: o.DAY,
        quantity: 1
      },
      label: T["d-n"],
      preffix: E["d-"]
    },
    {
      value: {
        unit: o.WEEK,
        quantity: 1
      },
      label: T["w-n"],
      preffix: E["w-"]
    },
    {
      value: {
        unit: o.MONTH,
        quantity: 1
      },
      label: T["m-n"],
      preffix: E["m-"]
    },
    {
      value: {
        unit: o.QUARTER,
        quantity: 1
      },
      label: T["q-n"],
      preffix: E["q-"]
    },
    {
      value: {
        unit: o.YEAR,
        quantity: 1
      },
      label: T["y-n"],
      preffix: E["y-"]
    }
  ]
}), Se = (e, t) => Object.values(e).flatMap((s) => s)[t], Z = (e) => {
  var d, p;
  const { metricDef: t, extraConf: s } = e, { formatPrecision: i, formatPrefix: r, formatSuffix: n, asRatio: a } = t, f = ((d = s == null ? void 0 : s.details) == null ? void 0 : d.type) === "prefix" ? s.details.value : r, c = ((p = s == null ? void 0 : s.details) == null ? void 0 : p.type) === "suffix" ? s.details.value : n, u = (s == null ? void 0 : s.decimals) ?? i;
  return {
    formatPrefix: f,
    formatSuffix: c,
    formatPrecision: u,
    growthInvert: (s == null ? void 0 : s.growthInvert) ?? !1,
    asRatio: a,
    unit: s == null ? void 0 : s.units
  };
};
export {
  W as A,
  _ as B,
  ce as C,
  oe as D,
  ue as E,
  B as F,
  Z as G,
  fe as H,
  g as I,
  de as a,
  Ae as b,
  ve as c,
  Q as d,
  pe as e,
  D as f,
  le as g,
  I as h,
  Y as i,
  V as j,
  j as k,
  ye as l,
  k as m,
  K as n,
  Te as o,
  L as p,
  Oe as q,
  xe as r,
  S as s,
  z as t,
  me as u,
  Ee as v,
  J as w,
  X as x,
  Re as y,
  Se as z
};
//# sourceMappingURL=utils-wNl4DVdv.js.map
